/*
 *   File : dashboard.js
 *   Author : https://evoqins.com
 *   Description : Home page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

//custom Component
import { DataTableComponent } from '../../Component/DataTable';
import { EditMasterFieldModal, AddFieldModal, DeleteModal } from '../../Component/Modal';
import { PrimaryButton } from '../../Component/Buttons';
import { CustomSearchInput } from '../../Component/FormElements';
import Loader from '../../Component/Others/loader';
import EmptyScreen from '../../Component/Others/empty';

import { APIService } from "../../Service";

const COMPONENT_LABELS = {
    text_input: "Text input",
    drop_down: "Dropdown",
    radio: "Radio",
    date_picker: "Date picker",
    mobile_input: "Mobile input",
};

const FieldMaster = () => {

    const [editId, setEditId] = useState(null);
    const [addField, setAddField] = useState(null);
    const [loading, setLoading] = useState(false);
    const [listField, setListField] = useState([]);
    const [editData, setEditData] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [deleteRow, setDeleteRow] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });
        _getMasterFields();
    }, []);

    useEffect(() => {
        if (addField !== null) {
            const add_field_modal = new Modal(document.getElementById('add-field-modal'));
            add_field_modal.show();
        }
    }, [addField]);


    useEffect(() => {
        if (editId !== null) {
            const edit_modal = new Modal(document.getElementById('edit-master-field-modal'));
            edit_modal.show();
        }
    }, [editId]);

    useEffect(() => {
        if (deleteRow !== null) {
            const edit_modal = new Modal(document.getElementById('delete-field-modal'));
            edit_modal.show();
        }
    }, [deleteRow]);

    // handle Edit
    const _handleEdit = (row) => {
        setEditId(row.id);
        setEditData(row);
    };

    const _handleAddField = () => {
        setAddField(true);
    }


    // API - Get field list
    const _getMasterFields = (query) => {
        setLoading(true);
        let is_post = true;
        const url = 'field-master/list';
        const data = {
            "name": query,
        }
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setListField(response.data);
            }
            else {
                setListField([]);
            }
            setLoading(false);
        });
    };


    // handle Delete
    const _handleDelete = (row) => {
        setLoading(true);
        let is_post = true;
        const url = 'field-master/delete';
        const data = {
            id: row.id,
        };
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
                _getMasterFields(searchValue); // refresh list
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoading(false);
        });
    };

    // table 
    const TABLE_COLUMNS = [

        {
            name: 'Field name',
            selector: row => row.name,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    <div>{row.name}</div>
                    <div className='e-primary-font e-font-12 e-font-weight-400 e-text-light-gray-1 pt-1'>
                        {COMPONENT_LABELS[row.component] || (row.component ? row.component : "Text input")}
                    </div>
                </div>
            ),
            width: "400px"
        },
        {
            name: 'Additional data field number',
            selector: row => row.data_field_number,
            cell: row => (
                <div>
                    {row.data_field_number ? row.data_field_number : "-"}
                </div>
            ),
            width: "140px"
        },
        {
            name: 'Additional data description',
            selector: row => row.description,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {row.description ? row.description : "-"}
                </div>
            ),
            width: "280px"
        },
        {
            name: 'Format',
            selector: row => row.param_format,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {row.param_format ? row.param_format : "-"}
                </div>
            ),
            width: "280px"
        },

        {
            name: 'Action',
            cell: (row) =>
                <div className='d-flex align-items-center gap-4'>
                    <div className="d-flex align-items-center cursor-pointer">
                        <img draggable={false} src={require("../../Assets/Images/Home/edit.svg").default}
                            className='me-1'
                            alt='Edit icon' />
                        <span className='e-edit-btn e-primary-font e-font-weight-500 e-font-14'
                            onClick={() => _handleEdit(row)}>Edit</span>

                    </div>
                    <div className="d-flex align-items-center cursor-pointer">
                        <img draggable={false}
                            src={require("../../Assets/Images/Home/delete.png")}
                            width={14}
                            height={14}
                            className='me-1'
                            alt='Delete icon' />
                        <span className='e-edit-btn e-primary-font e-font-weight-500 e-font-14'
                            onClick={() => setDeleteRow(row)}>Delete</span>

                    </div>
                </div>,
            width: "200px"
        }

    ];


    return (

        <div className='pt-3 padding-98px-bottom padding-32px-lr'>
            <h1 className='pt-3 e-primary-font e-font-weight-600 e-font-24'>Field master</h1>
            <div className='row '>
                <div className='offset-lg-6 col-lg-4 pe-3 my-auto'>
                    <div className='position-relative overflow-hidden '>
                        <CustomSearchInput placeholder="Search with field name"
                            type="text"
                            id="search"
                            require
                            search
                            value={searchValue}
                            className="w-100 padding-10px-tb"
                            // borderStyle="border-transparent"
                            labelStyle="e-font-weight-500"
                            handleChange={(e) => {
                                setSearchValue(e);
                                if (e === "") {
                                    _getMasterFields("");
                                }
                            }}
                            onKeyPress={() => {
                                _getMasterFields(searchValue)
                            }} />

                        {searchValue.length !== 0 &&
                            <span className='position-absolute h-100 top-0 px-3 d-flex align-items-center justify-content-center e-bg-primary-blue end-0 cursor-pointer'
                                style={{ borderRadius: "0 8px 8px 0" }}
                                onClick={() => _getMasterFields(searchValue)}>
                                <img src={require('../../Assets/Images/Home/arrow.svg').default}
                                    className=''
                                    width={14}
                                    height={14}
                                    alt='Search'
                                />
                            </span>}

                        {searchValue.length !== 0 &&
                            <img src={require('../../Assets/Images/Home/close.png')}
                                className='position-absolute top-14px right-64px cursor-pointer'
                                width={14}
                                height={14}
                                alt='Close'
                                onClick={() => {
                                    setSearchValue("");
                                    _getMasterFields("");
                                }} />
                        }
                    </div>
                </div>
                <div className='col-lg-2 text-end'>
                    <div className='d-flex gap-4 justify-content-end'>
                        <PrimaryButton name="Add field"
                            className="e-bg-primary-blue w-100"
                            onPress={_handleAddField} />

                    </div>
                </div>

            </div>

            {
                loading ? (
                    <Loader />
                ) : listField.length > 0 ? (
                    <div className='row mt-4'>
                        <div className='col-lg-12'>
                            <div className='e-table'>
                                <DataTableComponent
                                    columns={TABLE_COLUMNS}
                                    data={listField}
                                    pagination={false}
                                    paginationServer={false}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='h-100vh pt-5 mt-5'>
                        <EmptyScreen message="No data found" />
                    </div>
                )
            }

            {/* edit modal  */}
            {editId !== null &&
                <EditMasterFieldModal
                    fieldData={editData}
                    handleClose={() => {
                        setEditId(null);
                        setEditData(null);
                    }}
                    onUpdate={() => _getMasterFields(searchValue)} />
            }

            {/* Add field modal */}
            {addField === true &&
                <AddFieldModal
                    handleClose={() => setAddField(null)}
                    onSuccess={() => {
                        // Refresh the list after adding new field
                        _getMasterFields();
                        setAddField(null); // close modal
                    }}
                />
            }

            {deleteRow && (
                <DeleteModal
                    handleClose={() => setDeleteRow(null)}
                    onConfirm={() => _handleDelete(deleteRow)}
                />
            )}

        </div>

    )
}

export default FieldMaster;